import React from "react";

const ErrMapper = (err) => {
    return (
        <>
        {(err.err)  ? <>
            <span className="err"> {err.err} </span>
        </>:<></>}
        </>
    )
}
export default ErrMapper;
